document.addEventListener('DOMContentLoaded', function () {
const containers = document.querySelectorAll('.zoom-container');

containers.forEach((container) => {
    const image = container.querySelector('.pin-stm-image');

    container.addEventListener('mousemove', function (e) {
        const rect = container.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;

        const percentX = (offsetX / rect.width) * 100;
        const percentY = (offsetY / rect.height) * 100;

        // Set transform origin to mouse position
        image.style.transformOrigin = `${percentX}% ${percentY}%`;

        // Scale the image
        image.style.transform = 'scale(2)';
    });

    container.addEventListener('mouseleave', function () {
        image.style.transform = 'scale(1)';
        image.style.transformOrigin = 'center center';
    });
});
});

class ProductInformation extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSwiperSlider();
        this.addEventListener("input", this.handleInputEvents.bind(this))
        this.addEventListener("click", this.handleClickEvents.bind(this))
    }

    handleInputEvents(e) {
        if(e.target.closest(".pin-variant-picker")) {
            this.handleVariantInputEvent(e)
        }
    } 

    handleClickEvents(e) {
        let buyBtn = e.target.classList.contains("pin-buy-button") ? e.target : e.target.closest(".pin-buy-button")
        if(buyBtn) {
            e.preventDefault()
            this.handleBuyButtonClickEvent(buyBtn)
        }
    }

    handleBuyButtonClickEvent(btn) {
        btn.classList.add("loading")
        this.handleFormSubmit(btn)
    }

    handleVariantInputEvent(e) {
        this.filterBySelectedVariant(e.target.value)
    }

    handleFormSubmit(btn) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const form = btn.closest("form")
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            cart.renderContents(response)
          })
          .catch(err => console.log("form submit error"))
          .finally(() => {
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');  
            btn.classList.remove("loading")
          })
    }

    filterBySelectedVariant(id) {
        this.fetchData(id)
        this.updateURL(id)
    }
    updateURL(variantId) {
        if(this.dataset?.updateUrl === 'true')
        window.history.pushState({}, "", this.dataset.url + `?variant=${variantId}`);
    }

    fetchData(id) {
        fetch(this.dataset.url + `?variant=${id}&section_id=${this.dataset.section}`)
        .then(res => res.text())
        .then(res => {
            const html = new DOMParser().parseFromString(res, 'text/html')
            this.updateUI(html)
        })
    }

    updateUI(html) {
        if(html.querySelector(".pin-variant-picker") && document.querySelector(".pin-variant-picker")) {
            document.querySelector(".pin-variant-picker").innerHTML = html.querySelector(".pin-variant-picker").innerHTML
        }
        if(html.querySelector(".pin-stock-mesage") && document.querySelector(".pin-stock-mesage")) {
            document.querySelector(".pin-stock-mesage").innerHTML = html.querySelector(".pin-stock-mesage").innerHTML
        }
        if(html.querySelector(".pin-pf-selected-variant") && document.querySelector(".pin-pf-selected-variant")) {
            document.querySelector(".pin-pf-selected-variant").innerHTML = html.querySelector(".pin-pf-selected-variant").innerHTML
        }
        if(html.querySelector(".pin-pbb-wrapper") && document.querySelector(".pin-pbb-wrapper")) {
            document.querySelector(".pin-pbb-wrapper").innerHTML = html.querySelector(".pin-pbb-wrapper").innerHTML
        }
        // if(html.querySelector(".pin-pf-payment-btn") && document.querySelector(".pin-pf-payment-btn")) {
        //     document.querySelector(".pin-pf-payment-btn").innerHTML = html.querySelector(".pin-pf-payment-btn").innerHTML
        // }
    }

    initSwiperSlider() {
        if (this.gallerySwiper) this.gallerySwiper.destroy(true, true);
        this.gallerySwiper = new Swiper('.pin-gallery-swiper', {
            slidesPerView: 5,
            spaceBetween: 7,
            watchSlidesProgress: true,
        });

        if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
        this.thumbSwiper = new Swiper('.pin-thumb-swiper', {
            slidesPerView: 1,
            autoHeight: true,
            thumbs: {
                swiper: this.gallerySwiper,
            },
        });
    }
}

customElements.define('product-information', ProductInformation);
